import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';

import { SignUpSecurityModel } from '@core/models/sign-up-security.model';
import * as AuthActions from '@core/redux/auth/auth.actions';
import * as fromRoot from '@core/redux/index';
import { select, Store } from '@ngrx/store';
import { PasswordStrengthComponent } from '@ux/components/password-strength/password-strength.component';

@Component({
  selector: 'app-sign-up-step-2',
  templateUrl: './sign-up-step-2.component.html',
  standalone: true,
  imports: [NgClass, PasswordStrengthComponent, FormsModule, CommonModule, PasswordStrengthComponent],
  styleUrls: ['./sign-up-step-2.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignUpStep2Component implements OnInit, OnDestroy {
  private store = inject<Store<fromRoot.State>>(Store);

  private destroyRef = inject(DestroyRef);
  model: SignUpSecurityModel = new SignUpSecurityModel();
  isSending = false;
  validateErrors: any = {};

  constructor() {
    this.store.pipe(select(fromRoot.getAuthErrors), takeUntilDestroyed(this.destroyRef)).subscribe(errors => {
      this.validateErrors = errors;
    });

    this.store.pipe(select(fromRoot.getLoading)).subscribe(isSending => {
      this.isSending = isSending;
    });
  }

  ngOnInit() {}

  ngOnDestroy() {}

  onSubmit() {
    this.store.dispatch(new AuthActions.SignUpStepSecurityAction(this.model));
  }
}
